import React, { useState } from 'react';
import { Handle, Position, type NodeProps } from 'reactflow';
import type { PeopleTravelLocation } from '../../../../types';

export type LocationClusterData = {
  location: PeopleTravelLocation;
  eventCount: number;
  readOnly?: boolean;
  onLabelChange?: (locationId: string, label: string) => void;
};

const LocationClusterNode: React.FC<NodeProps<LocationClusterData>> = ({ data, selected }) => {
  const { location, eventCount, readOnly, onLabelChange } = data;
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState(location.label);

  const commit = () => {
    setEditing(false);
    const next = draft.trim() || location.label;
    if (next !== location.label) onLabelChange?.(location.id, next);
  };

  return (
    <div className={`people-travel-cluster ${selected ? 'is-selected' : ''}`}>
      <Handle type="target" position={Position.Left} className="people-travel-cluster-handle" />
      <Handle type="source" position={Position.Right} className="people-travel-cluster-handle" />
      <div
        className="people-travel-cluster-label nodrag"
        onDoubleClick={() => {
          if (readOnly) return;
          setDraft(location.label);
          setEditing(true);
        }}
      >
        {editing && !readOnly ? (
          <input
            className="people-travel-cluster-input nowheel"
            value={draft}
            autoFocus
            onChange={e => setDraft(e.target.value)}
            onBlur={commit}
            onKeyDown={e => {
              if (e.key === 'Enter') commit();
              if (e.key === 'Escape') {
                setDraft(location.label);
                setEditing(false);
              }
            }}
          />
        ) : (
          <span>{location.label}</span>
        )}
      </div>
      <div className="people-travel-cluster-meta">
        {(location.startDate || location.endDate) && (
          <span>
            {[location.startDate, location.endDate].filter(Boolean).join(' → ')}
          </span>
        )}
        <span>
          {eventCount} event{eventCount === 1 ? '' : 's'}
        </span>
      </div>
    </div>
  );
};

export default React.memo(LocationClusterNode);
